export default {
  notificationMixin () {
    return {
      notifications: {
        showError: {
          title: '',
          message: '',
          type: 'error',
          timeout: 1500
        },
        showSuccess: {
          title: '',
          message: '',
          type: 'success',
          timeout: 1500
        }
      }
    }
  }
}
